import {
  ADDITIONAL_PHONE_NUMBER_PATTERN,
  EMAIL_PATTERN,
  MOBILE_PHONE_NUMBER_PATTERN,
} from './constants';

export const selectData: components.UserTitle[] = ['', 'Mr', 'Mrs', 'Miss', 'Ms', 'Dr'];

export const inputData = [
  {
    data: {
      id: 'title',
      title: 'Title',
      validation: {
        required: 'Please enter a title',
      },
      selectData,
    },
  },
  {
    data: {
      id: 'firstName',
      title: 'First name',
      validation: {
        required: 'Please enter a first name',
        minLength: {
          value: 2,
          message: 'Please enter a first name',
        },
      },
      maxLength: 20,
    },
  },
  {
    data: {
      id: 'lastName',
      title: 'Last name',
      validation: {
        required: 'Please enter a last name',
        minLength: {
          value: 2,
          message: 'Please enter a last name',
        },
      },
      maxLength: 20,
    },
  },
  {
    data: {
      id: 'phone',
      title: 'Mobile phone number',
      validation: {
        required: 'Please enter a mobile phone number',
        pattern: {
          value: MOBILE_PHONE_NUMBER_PATTERN,
          message: 'Your mobile phone number should start with 07',
        },
        minLength: {
          value: 12,
          message: 'Looks like some digits are missing. Please enter the complete number',
        },
      },
    },
  },
  {
    data: {
      id: 'additionalPhoneNumber',
      title: 'Additional contact number (optional)',
      validation: {
        pattern: {
          value: ADDITIONAL_PHONE_NUMBER_PATTERN,
          message: 'Your additional contact number should start with 01, 02 or 07',
        },
        minLength: {
          value: 12,
          message: 'Looks like some digits are missing. Please enter the complete number',
        },
      },
    },
  },
  {
    data: {
      id: 'email',
      title: 'Email address',
      validation: {
        required: 'Please enter an email address',
        pattern: {
          value: EMAIL_PATTERN,
          message: 'Please enter a valid email address',
        },
        minLength: {
          value: 6,
          message: 'Please enter a valid email address',
        },
        maxLength: {
          value: 60,
          message: 'Please enter a valid email address',
        },
      },
    },
  },
];
